export const cropImage = (img, crop, type) => {
  const canvas = document.createElement('canvas')
  const scaleX = img.naturalWidth / img.width
  const scaleY = img.naturalHeight / img.height
  canvas.width = Math.floor(crop.width * scaleX)
  canvas.height = Math.floor(crop.height * scaleY)
  const ctx = canvas.getContext('2d')

  ctx.drawImage(
    img,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width * scaleX,
    crop.height * scaleY,
  )

  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) return console.error('Canvas is empty')

      resolve(blob)
    }, type || 'image/jpeg')
  })
}
